import { useQuery } from "@tanstack/react-query"
import { customerNotesQuery } from "../lib/customerNotesQuery"

export function useCustomerNotesQuery(...args: Parameters<typeof customerNotesQuery>) {
  return useQuery(customerNotesQuery(...args))
}
